export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fcffe7a4c605be8df23dac725af0106f72565acce&name=fetchTypeahead!'